import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { eventsApi } from '../api/events';
import { Button } from '../components/Button';

export function EventsList() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['events', 'mine'],
    queryFn: () => eventsApi.mine(),
  });

  return (
    <div className="container stack">
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <h1>Your events</h1>
        <Link to="/events/new"><Button variant="accent">+ New event</Button></Link>
      </div>

      {isLoading && <p className="muted">Loading…</p>}
      {error && <div className="error">Failed to load events</div>}
      {data?.events.length === 0 && (
        <div className="card stack" style={{ textAlign: 'center' }}>
          <p>No events yet.</p>
          <Link to="/events/new"><Button block>Create your first event</Button></Link>
        </div>
      )}
      <div className="stack">
        {data?.events.map((e) => (
          <Link key={e.id} to={`/e/${e.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className="card row" style={{ justifyContent: 'space-between' }}>
              <div className="row" style={{ gap: 12 }}>
                {e.logo_url ? (
                  <img src={e.logo_url} alt="" width={48} height={48} style={{ borderRadius: 8, objectFit: 'cover' }} />
                ) : (
                  <div style={{ width: 48, height: 48, background: 'var(--color-green-100)', borderRadius: 8 }} />
                )}
                <div>
                  <strong>{e.name}</strong>
                  <div className="muted" style={{ fontSize: 13 }}>
                    Code <strong>{e.short_code}</strong> · {e.format === 'best_ball_4some' ? 'Best Ball' : 'Stroke Play'} · {e.num_holes} holes
                  </div>
                </div>
              </div>
              <span className="badge">{e.status}</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
